import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { Box } from '../Box/index.js';
import { AccordionTrigger } from './AccordionTrigger.js';

/**
 * AccordionHeader contains the trigger for an item.
 *
 * _Note_: AccordionHeader and AccordionPanels have default padding of 'lg', which can be overridden.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/accordion#usage)
 * - [Props](https://blockparty.endpoint.com/components/accordion#props)
 * <br />
 *
 */
const AccordionHeader = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    iconLeft,
    iconRight,
    iconLeftName = 'ArrowCarrotRight',
    iconRightName = 'ArrowCarrotDown',
    children,
    dataTestId = 'accordion-header',
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box, {
    ref: forwardedRef,
    as: AccordionPrimitive.Header,
    "data-test-id": dataTestId,
    overflow: "visible",
    position: "relative"
  }, iconLeft ? /*#__PURE__*/React__default.createElement(AccordionTrigger, _extends({
    name: iconLeftName
  }, props, {
    iconPosition: "left"
  }), children) : /*#__PURE__*/React__default.createElement(AccordionTrigger, _extends({
    name: iconRightName
  }, props, {
    iconPosition: "right"
  }), children));
});
AccordionHeader.displayName = 'AccordionHeader';

export { AccordionHeader };
